import React from 'react';
import { UserPlus } from 'lucide-react';
import HRISListPage from '../HRISListPage';
import { getRecruitment, createJobOpening, updateJobOpening, deleteJobOpening } from '../hrisApi';

const STATUS_OPTIONS = ['Open', 'On Hold', 'Closed', 'Cancelled'];
const EMPLOYMENT_TYPES = ['Full-time', 'Part-time', 'Contract', 'Internship', 'Temporary'];

const columns = [
  { key: 'jobTitle', label: 'Job Title' },
  { key: 'department', label: 'Department' },
  { key: 'employmentType', label: 'Type' },
  { key: 'openings', label: 'Openings' },
  { key: 'postingDate', label: 'Posting Date' },
  { key: 'targetDate', label: 'Target Date' },
  { key: 'status', label: 'Status', badge: true },
];

const formFields = [
  { key: 'jobTitle', label: 'Job Title', type: 'text', required: true, placeholder: 'e.g. HR Generalist' },
  { key: 'department', label: 'Department', type: 'text', placeholder: 'Department' },
  { key: 'employmentType', label: 'Employment Type', type: 'select', options: EMPLOYMENT_TYPES, defaultValue: 'Full-time' },
  { key: 'openings', label: 'No. of Openings', type: 'number', required: true, placeholder: '1' },
  { key: 'postingDate', label: 'Posting Date', type: 'date' },
  { key: 'targetDate', label: 'Target Hire Date', type: 'date' },
  { key: 'status', label: 'Status', type: 'select', options: STATUS_OPTIONS, defaultValue: 'Open' },
  { key: 'description', label: 'Job Description', type: 'textarea', placeholder: 'Role responsibilities and requirements...' },
];

const Recruitment = () => (
  <HRISListPage
    title="Recruitment"
    description="Manage job openings, candidate pipeline, and hiring demand"
    icon={<UserPlus />}
    columns={columns}
    fetchData={getRecruitment}
    createData={createJobOpening}
    updateData={updateJobOpening}
    deleteData={deleteJobOpening}
    formFields={formFields}
    entityName="Job Opening"
    searchPlaceholder="Search job title, department, type..."
  />
);

export default Recruitment;
